import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createPartner, editPartner, showPartner } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { PartnerProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Partner() {
  return (
    <PartnerProvider>
      <Switch>
        <Route
          exact
          path={createPartner.spec}
          render={(props) => (
            <>
              <Can I="new" a="Partners">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Partners">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editPartner.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Partners">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Partners">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showPartner.spec}
          render={(props) => (
            <>
              <Can I="show" a="Partners">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Partners">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Partners">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Partners">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </PartnerProvider>
  );
}
export default Partner;
